import { render, staticRenderFns } from "./testimony.vue?vue&type=template&id=1f8827a9&scoped=true&"
import script from "./testimony.vue?vue&type=script&lang=js&"
export * from "./testimony.vue?vue&type=script&lang=js&"
import style0 from "./testimony.vue?vue&type=style&index=0&id=1f8827a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8827a9",
  null
  
)

export default component.exports